export default __webpack_public_path__ + "static/media/udemy.79265920.svg";